import { motion } from 'framer-motion'
import { useEffect, useState } from 'react'

import { VideoText } from '@/components/magicui/video-text'
import { cn } from '@/lib/utils'

const MD_MAX = '(max-width: 767px)'

interface Hero220Props {
  className?: string
}

const Hero220 = ({ className }: Hero220Props) => {
  const [narrow, setNarrow] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(MD_MAX).matches : false,
  )
  useEffect(() => {
    const mq = window.matchMedia(MD_MAX)
    const onChange = () => setNarrow(mq.matches)

    onChange()
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])

  return (
    <section
      className={cn(
        'relative flex h-svh min-h-[600px] flex-col items-center justify-center overflow-hidden pt-0',
        className,
      )}
    >
      <div className="relative h-full min-h-0 w-full max-w-none">
        <div className="absolute top-0 left-0 h-full w-full overflow-hidden bg-[url('/assets/images/heroimage.jpg')] bg-cover bg-center bg-no-repeat opacity-20" />
        <div
          className="pointer-events-none absolute inset-0 z-[1] bg-[radial-gradient(ellipse_72%_58%_at_50%_50%,rgb(0_0_0/_0.38),transparent_74%)]"
          aria-hidden
        />
        <div className="relative z-[2] flex h-full min-h-0 flex-col items-center justify-center gap-4">
          <motion.div
            initial={{ opacity: 0, scale: 1.1 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
            className="relative h-[min(720px,calc(100svh_-_12rem))] w-full shrink-0 px-3 sm:h-[min(800px,calc(100svh_-_10rem))] md:h-[min(900px,calc(100svh_-_8rem))]"
          >
            <VideoText
              src="/assets/video/vecteezy_aerial-view-of-sand-beach-and-water-surface-texture-foamy_7536782.mp4"
              className="font-playfair px-2 text-center font-bold tracking-tight"
              fontFamily="Playfair Display"
              fontSize="clamp(4.125rem,18.75vw,10.875rem)"
              fontWeight={600}
            >
              {narrow ? 'NK:\nOur Town' : 'NK: Our Town'}
            </VideoText>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export { Hero220 }
